var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"tipo-requerimento","rota-base":"/admin/tipo-requerimento","titulo-singular":"Tipo de Requerimento","campos-extras":[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }